module.exports = __webpack_public_path__ + "img/694fd4d54e14b11ae01ec9e6c38ad827.png";